import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class CreateMerchantMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.createMerchant.create_merchant_vat_search, (data) => {
      mixpanel.track(event.createMerchant.create_merchant_vat_search, { ...data });
    });
    AnalyticsEventBus.$on(event.createMerchant.create_merchant_create_1, (data) => {
      mixpanel.track(event.createMerchant.create_merchant_create_1, { ...data });
    });
    AnalyticsEventBus.$on(event.createMerchant.create_merchant_create_2, (data) => {
      mixpanel.track(event.createMerchant.create_merchant_create_2, { ...data });
    });
    AnalyticsEventBus.$on(event.createMerchant.create_merchant_complete_1, (data) => {
      mixpanel.track(event.createMerchant.create_merchant_complete_1, { ...data });
    });
    AnalyticsEventBus.$on(event.createMerchant.create_merchant_complete_2, (data) => {
      mixpanel.track(event.createMerchant.create_merchant_complete_2, { ...data });
    });
  }
}
